import { defineStore } from "pinia";

export const useGrowthBookStore = defineStore({
  id: "growthBook",
  state: () => ({
    billingPage: false,
    accountingIntegration: false,
    newsAndUpdateDashboard: false,
    marketingPage: false,
    voucherPage: false,
    pricingRulesPage: false,
  }),
});
